import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import SearchBar from '../../../../../../../../components/search-bar/SearchBar';
import { useComponentTasksTableQueryParams } from '../../../../../../../../hooks/useComponentTasksTableQueryParams';
import StatusFilter from '../../../../../../../../shared/components/status-filter/StatusFilter';
import { PCFRequestStatus } from '../../../../../../../../shared/enums/pcf-request';
import { serializeMulti } from '../../../../../../../../shared/helpers/url-parameter-parser';

const ALLOWED_COMPONENT_TASK_STATUSES = [
  PCFRequestStatus.Pending,
  PCFRequestStatus.Complete,
  PCFRequestStatus.Rejected,
];

const ComponentTasksTableHeader = () => {
  const { setParams, filters } = useComponentTasksTableQueryParams();
  const { t } = useTranslation();

  const onSearchChange = (value: string) => {
    setParams({ search: value, page: 1 });
  };

  const onStatusFilterChange = (selectedStatuses: string[]) => {
    setParams({
      status: serializeMulti(selectedStatuses),
      page: 1,
    });
  };

  return (
    <div className={classNames('flex justify-content-end align-items-center flex-wrap gap-2')}>
      <div className='flex w-full md:w-auto align-items-center justify-content-between'>
        <label className='hidden xl:block mr-2'>{t('componentsPage.filters')} </label>

        <div className='flex flex-column md:flex-row w-full md:mb-0'>
          <StatusFilter
            onStatusFilterChange={onStatusFilterChange}
            filters={filters}
            allowedStatuses={ALLOWED_COMPONENT_TASK_STATUSES}
          />
        </div>
      </div>

      <SearchBar onSearchChange={onSearchChange} initialValue={filters.search} />
    </div>
  );
};

export default ComponentTasksTableHeader;
